var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishersB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 1H2.875C2.37772 1 1.90081 1.1873 1.54917 1.5207C1.19754 1.8541 1 2.30628 1 2.77778V15.2222C1 15.6937 1.19754 16.1459 1.54917 16.4793C1.90081 16.8127 2.37772 17 2.875 17H14.125C14.6223 17 15.0992 16.8127 15.4508 16.4793C15.8025 16.1459 16 15.6937 16 15.2222V2.77778C16 2.30628 15.8025 1.8541 15.4508 1.5207C15.0992 1.1873 14.6223 1 14.125 1H10.375M4.75 1V9L7.5625 6.33333L10.375 9V1M4.75 1H10.375",
    stroke: "#23272E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishersB);
export default __webpack_public_path__ + "static/media/PublishersB.490d8edcf1ecf566f748fb466d4c4aef.svg";
export { ForwardRef as ReactComponent };